import { render } from "./Function.vue?vue&type=template&id=df812aee&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"

import "./Function.vue?vue&type=style&index=0&id=df812aee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\99170\\Desktop\\whole-project\\iridea-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df812aee"]])

export default __exports__